/** @file InspectorSection: a titled, collapsible block of the inspector. */
import type { ReactElement, ReactNode } from 'react';

/** Title, optional right-side text, an optional control after it (an info button), and the section body. */
export type InspectorSectionProps = { title: string; aside?: string; extra?: ReactNode; children: ReactNode };

/** A `<details>` block open by default, so sections fold without extra state. */
export function InspectorSection(props: InspectorSectionProps): ReactElement {
  return (
    <details open data-section={props.title} style={{ borderBottom: '1px solid var(--border, #2a2e38)', padding: '4px 8px' }}>
      <summary style={{ cursor: 'default', fontWeight: 600, display: 'flex', justifyContent: 'space-between' }}>
        <span>{props.title}</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: 'var(--muted, #8b919e)', fontWeight: 400 }}>{props.aside}{props.extra}</span>
      </summary>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, paddingTop: 4 }}>{props.children}</div>
    </details>
  );
}
